"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceView = void 0;
const typeorm_1 = require("typeorm");
const base_service_1 = require("./base-service");
const opportunity_1 = require("./opportunity");
const opportunity_service_1 = require("./opportunity-service");
const service_1 = require("./service");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const entity_1 = require("../util/entity");
const contact_profile_enum_1 = require("./contact-profile-enum");
const service_sortings_1 = require("./service-sortings");
const base_normalized_service_1 = require("./base-normalized-service");
let ServiceView = class ServiceView extends base_normalized_service_1.BaseNormalizedService {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        length: 18,
        name: 'opportunity__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "opportunityId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "api_id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 80,
        name: 'name_generated',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "nameGenerated", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'is_remote__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "remote", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'is_customer_sign_required__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "customer_sign_required", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'is_planning__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "planning", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'async_appointment__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "async_appointment", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'brand__c',
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "brand", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'sort_index',
    }),
    __metadata("design:type", Number)
], ServiceView.prototype, "sort_index", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.OneToOne)((type) => opportunity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({
        name: 'opportunity__c',
    }),
    __metadata("design:type", opportunity_1.Opportunity)
], ServiceView.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_active__c',
    }),
    __metadata("design:type", Boolean)
], ServiceView.prototype, "isActive", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'legacy__c',
    }),
    __metadata("design:type", Boolean)
], ServiceView.prototype, "legacy", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValuesFromPicklist('invoicetarget'),
    (0, typeorm_1.Column)('varchar', {
        name: 'invoicing_target__c',
        nullable: false,
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceView.prototype, "invoicingTarget", void 0);
ServiceView = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Service',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.ViewEntity)({
        expression: (connection) => {
            const baseServiceColumns = (0, entity_1.getEntityColumns)(base_service_1.BaseService, connection);
            const serviceColumns = (0, entity_1.getEntityColumns)(service_1.Service, connection).filter((ed) => !['opportunity__c'].includes(ed.databaseName));
            const opportunityServiceColumns = (0, entity_1.getEntityColumns)(opportunity_service_1.OpportunityService, connection);
            let qb = connection
                .createQueryBuilder()
                .addSelect('o.accountid', 'brand__c')
                .addSelect('service_sortings.sort_index AS sort_index')
                .addSelect('s.name_generated AS nameGenerated')
                .addSelect('COALESCE(os.invoicing_target__c, s.invoicing_target__c) AS invoicing_target__c')
                .from(service_1.Service, 's')
                .leftJoin(opportunity_service_1.OpportunityService, 'os', '(s.sfid = os.overrides_service__c)')
                .leftJoin(opportunity_1.Opportunity, 'o', '(os.opportunity__c = o.sfid)')
                .leftJoin(service_sortings_1.ServiceSortings, 'service_sortings', `(
          service_sortings.service_sfid = s.sfid
        )`)
                .where('o.sfid is not null');
            const columnsIterator = new entity_1.EntityColumnIterator({
                overrides_service__c: true,
                invoicing_target__c: true,
            });
            columnsIterator.all(baseServiceColumns, (columnName) => {
                if (['price_purchasing__c', 'price_selling__c', 'price_lists__c'].includes(columnName)) {
                    qb.addSelect(`
          CASE
            WHEN os.${columnName} = 111107777777 THEN NULL
            ELSE COALESCE(os."${columnName}", s."${columnName}")
          END
        `, columnName);
                }
                else {
                    qb.addSelect(`COALESCE(os."${columnName}", s."${columnName}")`, columnName);
                }
            });
            columnsIterator.all(serviceColumns, (columnName) => {
                if (['price_purchasing__c', 'price_selling__c', 'price_lists__c'].includes(columnName)) {
                    qb.addSelect(`
          CASE
            WHEN s.${columnName} = 111107777777 THEN NULL
            ELSE s."${columnName}"
          END
        `, columnName);
                }
                else {
                    qb.addSelect(`s."${columnName}"`, columnName);
                }
            });
            columnsIterator.all(opportunityServiceColumns, (columnName) => {
                if (['price_purchasing__c', 'price_selling__c', 'price_lists__c'].includes(columnName)) {
                    qb.addSelect(`
          CASE
            WHEN os.${columnName} = 111107777777 THEN NULL
            ELSE os."${columnName}"
          END
        `, columnName);
                }
                else {
                    qb.addSelect(`os."${columnName}"`, columnName);
                }
            });
            return qb;
        },
        name: 'service',
    })
], ServiceView);
exports.ServiceView = ServiceView;
//# sourceMappingURL=service-view.js.map